export const product = {
  product: {
    shape:
      '<path class="Icon__book-cover" paint-order="fill markers stroke" d="M2.886 2.305h12v7.756h-12z"/><path d="M2.886 3.394v9.333c0 .737.597 1.334 1.334 1.334h9.333c.736 0 1.333-.597 1.333-1.334V3.394c0-.736-.597-1.333-1.333-1.333H4.22c-.737 0-1.334.597-1.334 1.333z" stroke="#979797" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/><path d="M2.886 10.06h12" stroke="#979797" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path fill="none" paint-order="fill markers stroke" d="M2.886 2.305h12v7.756h-12z"/>',
    viewBox: [0, 0, 17, 17],
  },
};
